require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-introducing-mithril-js-a-new-javascript-mvc-framework.json") })
        }
      }, "path---blog-introducing-mithril-js-a-new-javascript-mvc-framework");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-introducing-mithril-js-a-new-javascript-mvc-framework!./.cache/json/blog-introducing-mithril-js-a-new-javascript-mvc-framework.json
// module id = 894
// module chunks = 231608221292675